/* eslint-disable react/prop-types */
import React from "react";
import { Box } from "@mui/material";
import Styles from "./FamilySubHeader.styles";
import Typography from "../common/new/Typography/Typography";

function FamilySubHeader({ label, id }) {
  return (
    <Box style={Styles.container}>
      <Typography style={Styles.title} variant="title2">
        {label}
      </Typography>
      {id && (
        <Typography style={Styles.familyId}>
          Family ID:{" "}
          <Typography as="span" color="#183053" fontWeight={500}>
            {id}
          </Typography>
        </Typography>
      )}
    </Box>
  );
}

export default FamilySubHeader;
